<div class="offline-bar" *ngIf="isLogged && (websocketsNotAvailable || isOffline)">
    <i class="fa-solid fa-wifi-slash me-3"></i>
    
    <div *ngIf="websocketsNotAvailable">{{ 'offline.liveDataNotAvailable' | translate}}</div>
    <div *ngIf="!websocketsNotAvailable">{{ 'offline.offlineBar' | translate}}</div>
    
    <button mat-button color="primary"
            class="close-btn my-5"
            *ngIf="mustRefresh"
            (click)="reloadPage()">
        {{ 'refresh' | translate }}
    </button>
    
    <i class="fas fa-times close-btn"
       *ngIf="!mustRefresh"
       (click)="closeOfflineBar()"></i>
</div>

<div class="offline-bar" *ngIf="!isLogged && isOffline">
    <i class="fa-solid fa-wifi-slash me-3"></i>
    <div>{{ 'offline.offlineBar' | translate}}</div>
    
    <button mat-button color="primary"
            class="close-btn my-5"
            *ngIf="mustRefresh"
            (click)="reloadPage()">
        {{ 'refresh' | translate}}
    </button>
</div>


